import { fetchScrapedData } from '../api/externalApi';

export const scrapeWebsite = async (url) => {

  try {
    console.log(`scrapeWebsite: Starting website scrape for: ${url}`);
    const data = await fetchScrapedData(url);
    console.log('scrapeWebsite: Scraped data:', data);
    
    // Extract the properties that ListingCard expects
    const { title, description, email, image, location, category } = data;
    
    return {
      title: title,
      description: description,
      url: url,
      email: email,
      image: image,     
      location: location,
      category: category
    };
  } catch (error) {
    console.error('scrapeWebsite: Error scraping website:', error);
    return null;
  }
};
